import { useEffect, useState } from "react";
import { STALE_EVENT, clearStaleReloadMarker } from "../../utils/staleClientRecovery";
import StaleClientPrompt from "./StaleClientPrompt";

/**
 * Catches stale JS bundle failures after deploys and guides users to refresh
 * (auto-reload once, then show a clear prompt).
 */
export default function StaleClientRecovery() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => clearStaleReloadMarker(), 5000);
    const onStale = () => setVisible(true);
    window.addEventListener(STALE_EVENT, onStale);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener(STALE_EVENT, onStale);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="stale-client-overlay" role="presentation">
      <StaleClientPrompt />
    </div>
  );
}
